import React, { useState } from 'react';
import { Printer } from 'lucide-react';
import { Button } from '../../../../../components/ui/Button';
import { ErrorState } from '../../../../../components/ui/ErrorState';
import { mergePDFSFromUrls } from '../../../../../services/pdfService';

/**
 * Prints every label of a shipment in one go: merges the PDFs and opens the
 * result, the way the OMS's order detail does, so a three-box shipment is one
 * sheet to send to the printer instead of three tabs.
 *
 * Disabled, it says what is missing.
 *
 * @param {object} props
 * @param {string[]} props.urls - The labels to merge, already public.
 * @param {string} props.testId
 * @param {string} [props.label] - What the button says when there is something to print.
 */
export const PrintLabelsButton = ({ urls, testId, label }) => {
  const [printing, setPrinting] = useState(false);
  const [error, setError] = useState(null);

  const print = async () => {
    setError(null);
    setPrinting(true);
    try {
      const merged = await mergePDFSFromUrls(urls);
      window.open(URL.createObjectURL(merged), '_blank', 'noopener,noreferrer');
    } catch (failure) {
      setError(failure?.message || 'No se pudieron unir las etiquetas');
    } finally {
      setPrinting(false);
    }
  };

  const text = label || `Imprimir ${urls.length === 1 ? 'etiqueta' : 'etiquetas'}`;

  return (
    <div className="flex flex-col items-end gap-3">
      {error && (
        <div data-testid={`${testId}-error`} className="w-full">
          <ErrorState variant="inline" title="No se pudieron imprimir" description={error} />
        </div>
      )}
      <Button
        variant="primary"
        icon={Printer}
        loading={printing}
        loadingLabel="Uniendo etiquetas..."
        disabled={urls.length === 0}
        title={urls.length === 0 ? 'Todavía no hay etiquetas que imprimir' : undefined}
        onClick={print}
        data-testid={testId}
      >
        {urls.length === 0 ? 'Sin etiquetas aún' : text}
      </Button>
    </div>
  );
};
